import { render, staticRenderFns } from "./PracticesEmbed.vue?vue&type=template&id=77f92d20&scoped=true&"
import script from "./PracticesEmbed.vue?vue&type=script&lang=js&"
export * from "./PracticesEmbed.vue?vue&type=script&lang=js&"
import style0 from "./PracticesEmbed.vue?vue&type=style&index=0&id=77f92d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f92d20",
  null
  
)

export default component.exports